import classNames from 'classnames'

import { ImageComponent } from '@apps-common/components/common'
import { RadionetLogo } from '@apps-common/components/common/logos/RadionetLogo'
import { THEME_NO_IMG_VALUE } from '@apps-common/config/theme'
import { useTheme } from '@apps-common/hooks/useTheme'
import { useWindowDimensions } from '@apps-common/hooks/useWindowDimensions'

import { RadionetLogoOnly } from './RadionetLogoOnly'

interface IProps {
  containerClasses?: string
  imageClasses?: string
}

export const CompanyLogo: React.FC<IProps> = ({ containerClasses, imageClasses }) => {
  const { isMobile } = useWindowDimensions()
  const { getLogoUrl } = useTheme()

  const logoPrimary = getLogoUrl('primary')
  const logoSecondary = getLogoUrl('secondary')

  const logo = logoPrimary || logoSecondary

  if (logo && logo?.length > 0 && logo !== THEME_NO_IMG_VALUE) {
    return (
      <ImageComponent
        src={`${logo}?${new Date().toISOString()}`}
        alt='Company large logo'
        containerClasses={classNames(
          containerClasses,
          'relative left-[-5px] bottom-[-5px] p-[6px] rounded-[12px] bg-logo-bg',
          isMobile && 'hidden'
        )}
        imageClasses={classNames(imageClasses, 'max-w-[140px] max-h-[24px]')}
        errorIconClasses='absolute top-0 left-0 text-[2.5em] opacity-60 text-text-muted'
      />
    )
  }

  return (
    <div className='relative left-[-5px] p-[6px] rounded-[12px] bg-logo-bg'>
      <RadionetLogo color='fill-text-muted' classes='hidden sm:inline-block w-[140px] h-[24px]' />
      <RadionetLogoOnly color='fill-text-muted' classes='inline-block sm:hidden w-[35px] h-[32px]' />
    </div>
  )
}
